/**
 * 階層タグ情報からタグ名を抽出する関数。
 *
 * @param {Object} tagsObject - ネストされたタグオブジェクト。
 * @returns {string[][]} 各階層における抽出されたタグ名の2重配列。
 */
const parseTagNames = tagsObject => {
  const tagNamesByLevel = [];
  if (tagsObject) {
    Object.keys(tagsObject).forEach(outerKey => {
      const tagGroup = tagsObject[outerKey];
      const tagNames = [];

      for (let i = 1; i <= 5; i += 1) {
        const tagName = `tag${i}`;
        if (typeof tagGroup[tagName] === 'string') {
          tagNames.push(tagGroup[tagName]);
        } else if (tagGroup[tagName] && tagGroup[tagName].name) {
          tagNames.push(tagGroup[tagName].name);
        }
      }

      tagNamesByLevel.push(tagNames);
    });
  }
  return tagNamesByLevel;
};

export default parseTagNames;
